import { useState, useEffect } from 'react';

// Feature flag for inbound mode
// This controls UI visibility and logic gating for inbound functionality
export const useInboundFeatureFlag = () => {
  const [enableInboundMode, setEnableInboundMode] = useState(true);

  useEffect(() => {
    // Check for feature flag from environment or settings
    // For now, defaulting to enabled for implementation
    const flagValue = localStorage.getItem('enableInboundMode');
    if (flagValue !== null) {
      setEnableInboundMode(flagValue === 'true');
    }
  }, []);

  const toggleInboundMode = (enabled: boolean) => {
    setEnableInboundMode(enabled);
    localStorage.setItem('enableInboundMode', enabled.toString());
  };

  return {
    enableInboundMode,
    toggleInboundMode
  };
};